import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
@Component({
  selector: 'app-organization-employee-ne',
  template: require('./organization-employee-ne.component.html')
})
export class OrganizationEmployeeNeComponent extends BaseComponent implements OnInit {

  public employee = {
      title:null,
    firstname:"",
    lastname:"",
    position:"",
    email:"",
    passw:"",
    joinedOn:"12/1/2018",
    managerId:-1,
    departmentId:-1,
    isManager:false,
    managers: []
  };

  public titles = 
                ["Mr.",
                "Mrs.",
                "Ms.",
                "Miss.",
                "Dr.",
                "Sir",
                "Prof.",
                "Master",
                "Hon."];

  public employeeId = -1;
  public organizationId = -1;

  public departments = [];
  public managers = [];
  public remainingManagers = [];

  ngOnInit() {
    super.ngOnInit();

    this.loadDepartments();
    this.loadManagers();
  }


  public loadDepartments() {
    this.lsApi.getDepartments(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.departments = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  public getManagerById(id) {
      for(var i=0;i<this.managers.length;i++) {
          var m = this.managers[i];
          if(m.employeeId == id) {
              return m;
          }
      }
      return null;
  }

  public ManagerSelected() {
      var m = this.getManagerById(this.employee.managerId);
      if(m!=null) {
          if(m.department!=null) {
              this.employee.departmentId = m.departmentId;
          }
      }
  }

  public updateRemainingManagers() {
      this.remainingManagers = [];
      this.managers.forEach(manager => {
          if(this.employee.managers.findIndex(x => x.employeeId == manager.employeeId)==-1){
              this.remainingManagers.push(manager);
          }
      });
  }

  public getDepartment(mgr) {
    if(mgr.department!=null)
      return " (" + mgr.department.name + ")";
    else
      return "";
  }

  public loadManagers() {
    this.lsApi.getManagers(this.organizationId, this.employeeId).subscribe(resp => {
        if(resp.status) {
            this.managers = resp.data;
            this.remainingManagers = this.managers;
            this.updateRemainingManagers();
        }
    },
    error => {
        console.log(error);
    });
  }

  public addManager() {
      var id = $("#coSelectedManager").val();
    var manager = this.getManagerById(id);
    if(this.employee.managers.findIndex(x => x.employeeId == manager.employeeId)==-1) {
        this.employee.managers.push(manager);
    }
    this.updateRemainingManagers();
  }

  public removeManager(manager) {
      var index = this.employee.managers.findIndex(x => x.employeeId == manager.employeeId);
      if(index>=0) {
        this.employee.managers.splice(index,1);
      }
      this.updateRemainingManagers();
  }

  public routeParamsUpdated() {
    this.organizationId = this.default(this.currentRouteParams["orgId"],-1);
    this.employeeId = this.default(this.currentRouteParams["empId"],-1);
    if(this.employeeId>0)
      this.loadEmployeeById();
    else 
      this.employeeId = -1;
  }

  public loadEmployeeById() {
      this.busy = this.lsApi.getEmployeeById(this.employeeId).subscribe(resp => {
        if(resp.status) {
            this.employee = resp.data[0];
            this.updateRemainingManagers();
            console.log(this.employee);
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();
    var ism = 0;
    console.log(this.employee.isManager);
    var errorMessage = "";
    if(validate.isEmpty(this.employee.firstname)) {
        errorMessage = "Please provide a firstname for this employee";
    }
    else if(validate.isEmpty(this.employee.lastname)) {
        errorMessage = "Please provide a lastname for this employee";
    }
    else if(validate.isEmpty(this.employee.position)) {
        errorMessage = "Please provide a position for this employee";
    }
    else if(validate.isEmpty(this.employee.email)) {
        errorMessage = "Please provide a email for this employee";
    }
    else if(this.employee.departmentId<=0) {
        errorMessage = "Please select a department for this employee";
    }
    /*
    else if(this.employee.isManager==false) {
      // Not a manager
      ism = 0;
      if(this.employee.managerId<=0) {
        errorMessage = "Please select a manager for this employee";
      }
    }
    else if(this.employee.isManager==true) {
      // Is a manager
      ism = 1;
      if(this.employee.departmentId<=0) {
        errorMessage = "Please select a department for this employee";
      }
    }
    */

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        var ids = this.getManagerIds();
        this.busy = this.lsApi.saveEmployee(this.employeeId,this.employee.title, this.employee.firstname, this.employee.lastname,this.employee.position,
            this.employee.joinedOn,
          this.employee.email,this.employee.passw,this.organizationId,ids,
          this.employee.departmentId,ism).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/organizations',this.organizationId,'employees']).then(() => {
                  this.appToast.success("Employee Successfully Saved","Employee Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public getManagerIds() {
      var ids = "";
      this.employee.managers.forEach(manager => {
        ids += "," + manager.employeeId;
      });
      if(ids.length>0) {
          ids = ids.substr(1);
      }
      return ids;
  }

  public cancel() {
    this.router.navigate(['/admin/organizations',this.organizationId,'employees']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.employee.firstname + " " + this.employee.lastname + "' employee and all their data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteEmployeeById(this.employeeId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/organizations',this.organizationId,'employees']).then(() => {
                    this.appToast.success("Employee Successfully Deleted","Employee Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-employee-ne/organization-employee-ne.component.ts